import { CombinedAlertProps } from './A1Alerts.types';
import { AlertProps } from '@ahc-digital/component-library';
import { useI18n } from 'next-localization';
import { useCookies } from 'react-cookie';
import { getCookieName } from './A1Alerts';
import { useConditionalRendering } from 'src/shared/useConditionalRendering';

export function GetAlertModel(props?: CombinedAlertProps, isDismissed?: boolean): AlertProps {
  const { t } = useI18n() || {};

  const dismissPeriod = props?.dismissPeriod;
  const cookieName = getCookieName(props?.uid);

  const { renderRichText } = useConditionalRendering();

  const expiration = () => {
    const d = new Date();
    switch (dismissPeriod) {
      case 'day':
        d.setDate(d.getDate() + 1);
        break;
      case 'week':
        d.setDate(d.getDate() + 7);
        break;
      case 'month':
        d.setMonth(d.getMonth() + 1);
        break;
      case 'session':
        return undefined;
    }

    return d;
  };

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [_cookies, setCookie] = useCookies([cookieName]);
  return {
    alertType: props?.alertType || 'info',
    alertFunction: props?.alertFunction || 'dismissible',
    shouldHideIcon: Boolean(props?.shouldHideIcon),
    primaryAlertText: renderRichText({ value: props?.primaryAlertText }),
    expandedAlertText: renderRichText({ value: props?.expandedAlertText }),
    mobileAlertText: renderRichText({ value: props?.mobileAlertText }),
    showMoreLabel: t('Alert-ShowMore'),
    showLessLabel: t('Alert-ShowLess'),
    isDismissed: isDismissed,
    onDismiss: () => {
      setCookie(cookieName, 'true', { expires: expiration(), path: '/' });
    },
  };
}
